module.exports = __webpack_public_path__ + "static/media/18ECA47.b8232d3e.jpg";